import {TextFieldTypes, TextFieldFieldForm} from '../../../fields/textField/types'

// Default values for each text field type
const getDefaultValue = (fieldType: TextFieldTypes): string => {
  switch (fieldType) {
    case 'poNumber':
      return 'PO-' + new Date().getFullYear() + '-' + String(Date.now()).slice(-6) // Generate a default PO number
    case 'driverInstructions':
      return '' // Driver instructions are optional
    case 'additionalNotes':
      return '' // Additional notes are optional
    case 'concreteUsage':
      return '' // This is handled by the usage selection component
    default:
      return ''
  }
}

const buildTextFieldForm = <T extends TextFieldTypes>(fieldType: T): TextFieldFieldForm<T> => {
  return {
    [fieldType]: getDefaultValue(fieldType)
  } as TextFieldFieldForm<T>
}

export const buildAdditionalNotesForm = () => buildTextFieldForm('additionalNotes')
export const buildDriverInstructionsForm = () => buildTextFieldForm('driverInstructions')
export const buildPoNumberForm = () => buildTextFieldForm('poNumber')
